import React, { useState } from 'react';
import { View } from 'react-native-web';
import BreakLine from '../General/BreakLine';
import {
  action_bar_details,
  Bank_logo,
  bank_logo_details, bank_logo_details_qab,
  Disabled_Logo,
  Hot_key_str, Hotkey_QAB_str,
  iMessage_bar_str,
  iMessage_details, menu_design,
  menu_screen,
  service_action_bar, service_icons,
  service_iMessage, top_section,
} from '../../../utils/DictionaryManagementUtils';
import UploadMenu from './UploadMenu';
import Title from '../Text/Title';
import ExpandedText from '../Buttons/ExpandedText';
import MenuDesign from '../Layout/MenuDesign';

//= ========================================================================

const UploadLogoMenu = ({
  globJSON,
  onConfigChanged,
  onValueChanged,
  headline,
  setMessagePopupState,
  language,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { services } = globJSON.configurations;
  const { layout_menu_screen } = globJSON.configurations.services.menu;
  const bankLogos = [
    {
      subHeadline: menu_screen,
      fileId: 'configurations/services/menu/bank_logo',
    }, {
      subHeadline: Hot_key_str,
      fileId: 'configurations/services/menu/keyboard_logo',
    }, {
      isHide: layout_menu_screen,
      subHeadline: Hotkey_QAB_str,
      fileId: 'configurations/services/menu/hotkey_qab',
    }, {
      isHide: !globJSON.configurations.deliverables.deliverables.iMsg_enabled,
      subHeadline: iMessage_bar_str,
      fileId: 'configurations/services/menu/iMsg_bank_logo',
    }, {
      subHeadline: Disabled_Logo,
      fileId: 'configurations/services/menu/keyboard_disabled_logo',
      disableMode: true,
    },
  ];
  const actionBarIcons = services.screens_ordering
    .filter((serviceKey) => services[serviceKey].selected)
    .map((serviceKey) => ({
      subHeadline: services[serviceKey].name,
      fileId: `configurations/services/${serviceKey}/icon_action_bar`,
    }));
  const iMessageIcons = services.screens_ordering
    .filter((serviceKey) => services[serviceKey].selected)
    .map((serviceKey) => ({
      subHeadline: services[serviceKey].name,
      fileId: `configurations/services/${serviceKey}/icon`,
    }));

  return (
    <View>
      {layout_menu_screen
      && (
      <MenuDesign
        globJSON={globJSON}
        onConfigChanged={onConfigChanged}
        onValueChanged={onValueChanged}
        headline={menu_design}
        subHeadline={top_section}
        language={language}
        showAccountBalance
      />
      )}
      <BreakLine marginTop={30} />
      <ExpandedText
        isExpanded={isExpanded}
        onPress={() => setIsExpanded(!isExpanded)}
      >
        <Title marginBottom={0} isBold>{headline}</Title>
      </ExpandedText>
      {isExpanded
            && (
            <View>
              <View style={{ flexDirection: 'column', flexWrap: 'wrap' }}>
                <UploadMenu
                  globJSON={globJSON}
                  onConfigChanged={onConfigChanged}
                  setMessagePopupState={setMessagePopupState}
                  headline={Bank_logo}
                  details={layout_menu_screen ? bank_logo_details : bank_logo_details_qab}
                  listObject={bankLogos}
                  marginBottom={20}
                  marginTop={13}
                />
                {!layout_menu_screen
                 && (
                 <UploadMenu
                   globJSON={globJSON}
                   onConfigChanged={onConfigChanged}
                   setMessagePopupState={setMessagePopupState}
                   headline={service_action_bar}
                   details={action_bar_details}
                   listObject={actionBarIcons}
                   marginBottom={10}
                 />
                 )}
                {!layout_menu_screen
                && (
                <MenuDesign
                  globJSON={globJSON}
                  onConfigChanged={onConfigChanged}
                  onValueChanged={onValueChanged}
                  headline={menu_design}
                  subHeadline={top_section}
                  language={language}
                />
                )}
                <UploadMenu
                  globJSON={globJSON}
                  onConfigChanged={onConfigChanged}
                  setMessagePopupState={setMessagePopupState}
                  headline={layout_menu_screen ? service_icons : service_iMessage}
                  details={iMessage_details}
                  listObject={iMessageIcons}
                  marginBottom={12}
                  marginTop={30}
                />
              </View>
            </View>
            )}
    </View>
  );
};

export default UploadLogoMenu;
